import { useState } from 'react'
import { Banner, Button, ErrorState, Skeleton } from '@shared/design-system/ui'
import { useDefaultReceivingPlan } from '../api/admin-receiving-plan'
import { AdminReceivingPlanEditor } from './AdminReceivingPlanEditor'
import { PlanConditions } from './PlanConditions'
import * as styles from './receiving-plan.css'

export function DefaultReceivingPlanPanel() {
  const query = useDefaultReceivingPlan()
  const [editing, setEditing] = useState(false)

  if (query.isPending) return <Skeleton height={350} />
  if (query.isError)
    return (
      <ErrorState
        title="Não foi possível carregar o plano padrão"
        onRetry={() => void query.refetch()}
      />
    )

  return (
    <section
      className={`${styles.section} ${styles.stack}`}
      aria-label="Plano padrão de todos os usuários"
      data-testid="default-receiving-plan-panel"
    >
      <div className={styles.header}>
        <div className={styles.stack}>
          <h2 className={styles.heading}>Plano padrão</h2>
          <p className={styles.copy}>
            Condições usadas por todos os usuários nos campos sem personalização.
          </p>
        </div>
        <Button data-testid="default-receiving-plan-edit-btn" onClick={() => setEditing(true)}>
          Editar plano padrão
        </Button>
      </div>
      <PlanConditions plan={query.data} />
      <Banner tone="info" title="Como a mudança se aplica">
        Cada campo personalizado mantém seu valor. Os demais acompanham o novo padrão. A reserva
        muda após a confirmação da Stripe para cada usuário, em novas vendas. Confira a aplicação no
        plano do usuário. Operações já registradas mantêm suas condições originais.
      </Banner>
      <div className={styles.stack} aria-label="Histórico do plano padrão">
        <h3 className={styles.heading}>Histórico de alterações</h3>
        {query.data.history.map((entry) => (
          <div className={styles.history} key={entry.versionId}>
            <div className={styles.header}>
              <strong>{entry.actorName}</strong>
              <time dateTime={entry.effectiveFrom}>
                {new Date(entry.effectiveFrom).toLocaleString('pt-BR')}
              </time>
            </div>
            <p className={styles.copy}>{entry.reason}</p>
          </div>
        ))}
      </div>
      {editing ? (
        <AdminReceivingPlanEditor
          scope="default"
          userId="default"
          userLabel="Todos os usuários"
          data={{ current: query.data, standards: [query.data] }}
          onClose={() => setEditing(false)}
        />
      ) : null}
    </section>
  )
}
